import { gateway } from "../../../gateway";

export const getCompanyHours = async (period: string) => {
    const response = await gateway.get(`/timesheets/total-hours/company?period=${period}`);
    return response.data?.data || response.data;
}